module.exports = __webpack_public_path__ + "media/images/incarcerated_girls/CentralJuvie-3_BW2-f2cc2624196dfad922eddff3cc85c38b.jpg";